import { service, model } from 'eco-cli'
import moment from 'moment';
import { VipArticle, QuestionArticle, WorkorderArticle, File } from "../models/Article";
const { forum, worksheet, finance } = service

export const getQuestionList = () => forum.withToken.get("/community/question/getCurrentUserQuestion/10")
    .then((list) => {
        return list.map(json => {
            return Object.assign(new QuestionArticle(), {
                id: json.id,
                title: json.title,
                url: `/community/question/${json.id}`,
                createTime: moment(json.createTime),
                updateTime: moment(json.updateTime),
                replyCount: json.respCount
            })
        })
    })

export const getWorkorderList = () => worksheet.withToken.get("/worksheet/workOrder/getCurrentUserWorkOrder/10")
    .then((list) => {
        return list.map(json => {
            return Object.assign(new WorkorderArticle(), {
                id: json.id,
                title: json.title,
                createTime: moment(json.createTime),
                updateTime: moment(json.updateTime),
                url: `/user-center/worksheet/${json.id}`,
                status: {
                    '1': 'wait',
                    '2': 'process',
                    '3': 'resolved',
                    '4': 'complete',
                    '5': 'rejected',
                }[json.status]
            })
        })
    })

export const getBugsAndVersions = () => finance.withToken.get("/vip/getUpdateAndBugDataInfo/10")
    .then((data) => {
        const { versionInfo, bugInfo ,bugInfoBackgroundUrl,versionBackgroundUrl} = data
        const tabs = [
            { title: versionInfo.name, key: "versions" },
            { title: bugInfo.name, key: "bugs" },
        ]
        const versions = versionInfo.vipData.map(json => Object.assign(new VipArticle(), {
            id: json.id,
            title: json.title,
            url: `/details/${json.id}`,
            isTop: json.isTop,
            bg: versionBackgroundUrl,
            createTime: moment(json.createTime),
            updateTime: moment(json.updateTime),
            publishTime: moment(json.publishTime),
        }))


        const bugs = bugInfo.vipData.map(json => Object.assign(new VipArticle(), {
            id: json.id,
            title: json.title,
            url: `/details/${json.id}`,
            bg: bugInfoBackgroundUrl,
            isTop: json.isTop,
            createTime: moment(json.createTime),
            updateTime: moment(json.updateTime),
            publishTime: moment(json.publishTime),
        }))

        return { tabs, versions, bugs }
    })

// 获取同类问题
export const getSameQuestions = (questionId) => finance
    .withToken.get("/community/finance/otherQuestion/" + questionId, { type: 'vip' })
    .then((res) =>
        res.map((json) => {
            return Object.assign(new VipArticle(), {
                title: json.title,
                id: json.id,
                url: `/details/${json.id}`,
                createTime: moment(json.createTime),
                updateTime: moment(json.updateTime),
                publishTime: moment(json.publishTime),
                file: json.fileList && json.fileList[0] ?
                    Object.assign(new File(), {
                        type: File.type(json.fileList[0].fileSuffix),
                        size: File.size(json.fileList[0].fileSize)
                    }) : null
            })
        })
    );